var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.color},[_vm._v(_vm._s(_vm._f("dayschedule")(_vm.result)))])
}
var staticRenderFns = []

export { render, staticRenderFns }